import { animate, style, transition, trigger } from '@angular/animations';

export interface INavbarData {
  routeLink?: string;
  icon?: string;
  label: string;
  expanded?: boolean;
  items?: INavbarData[];
  visible?: boolean;
  // Se muestra pero no navega (ej. falta el permiso); disabledReason va como tooltip.
  disabled?: boolean;
  disabledReason?: string;
  command?: () => void;
}

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('350ms', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('350ms', style({ opacity: 0 }))]),
]);
